import CardLocation from '@alltrails/amplitude/enums/CardLocation';
import { LocationDetailsResponseType } from '@/types/locationDetailsPages/shared';

export const getAnalyticsCardLocation = (type?: LocationDetailsResponseType): CardLocation | undefined => {
  switch (type) {
    case 'poi':
      return 'poi page';
    case 'park':
      return 'park page';
    default:
      return 'location page';
  }
};
